export const apiSystemKey = '/api/system-keys'
export const apiSystemKeyAdminList = '/api/system-keys/admin-list'
export const apiSystemKeyByParent = '/api/system-keys/by-parent'
export const apiSystemKeyCombobox = '/api/system-keys/combobox'
export const apiSystemKeyById = (id: number) => `/api/system-keys/${id}`
export const apiSystemKeyBulkDelete = '/api/system-keys/bulk-delete'
export const apiSystemKeyInvalidateCache = '/api/system-keys/invalidate-cache'
export const apiSystemKeyClearAllCache = '/api/system-keys/clear-all-cache'
